<script lang="ts" module>
	import Button from "@components/common/Button.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import { Auth } from "@utils/Auth.svelte.js";
	import { AuthChannel } from "@utils/AuthChannel.js";
	import { getTranslate } from "@utils/getTranslate.js";
	import googleLogo from "@core/assets/images/google-logo.svg?raw";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { createReactiveBreakpoint } from "@core/utils/createReactiveBreakpoint.js";
	import { expectErrorMessage } from "@core/utils/expectErrorMessage.js";
	import { createPromiseWithStatus } from "@core/utils/svelte/createPromiseWithStatus.svelte.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./SignInWithGoogle.translations.json" with { type: "json" };
</script>

<script lang="ts">
	const isDesktop = createReactiveBreakpoint(">md");
	const translate = getTranslate(translations);

	const { tenant } = getGlobalTemplateProps();
	const signInWithAPopup = createPromiseWithStatus(Auth.initiateGoogleSignIn.bind(Auth, tenant.locale));

	const errorMessage = $derived(
		signInWithAPopup.value.status === "error" &&
			expectErrorMessage(
				signInWithAPopup.value.error,
				tenant.locale,
				{
					PopupBlockedError: translate("popupBlocked"),
					PopupClosedError: "",
				},
				translate("unspecifiedError"),
			),
	);
</script>

<Button
	type="button"
	variant={ButtonVariant.Outlined}
	size={isDesktop.current ? ButtonSize.Large : ButtonSize.Medium}
	class="justify-between normal-case tracking-normal"
	onclick={async (): Promise<void> => {
		const popup = window.open("about:blank", "_blank", "width=500,height=600");
		const authChannel = new AuthChannel();

		try {
			await signInWithAPopup.call(popup, authChannel);
		} catch {
			// Error is tracked in signInWithAPopup.value
		} finally {
			authChannel.close();
		}
	}}
	loading={signInWithAPopup.value.status === "loading"}
>
	<Icon icon={googleLogo} class="size-6" />
	<Formatted text={translate("continueWithGoogle")} />
	<div class="size-6"></div>
</Button>

{#if errorMessage}
	<p class="text-sm text-fcrerror mt-2">
		<Formatted text={errorMessage} />
	</p>
{/if}
